export type IncidentInput = { anomalies: Array<{ ts:string; severity:number; deviceId:string }>; suppliers: Array<{ id:string; rating:number }>; };
export type Cause = { label: string; score: number };

export function detectRootCauses(i: IncidentInput): Cause[] {
  const anomalyScore = Math.min(1, (i.anomalies.reduce((a,b)=>a+b.severity,0)/Math.max(1,i.anomalies.length))/5);
  const supplierLow = i.suppliers.filter(s=>s.rating<60).length/Math.max(1,i.suppliers.length);
  const causes: Cause[] = [
    { label: 'IoT sensor drift', score: parseFloat((anomalyScore*0.6).toFixed(2)) },
    { label: 'Low-rated supplier impact', score: parseFloat((supplierLow*0.5).toFixed(2)) },
    { label: 'Process variance', score: 0.3 }
  ];
  return causes.sort((a,b)=> b.score - a.score).slice(0,3);
}



















